import React, { useEffect } from 'react';
import WOW from 'wowjs';
import { Link } from 'react-router-dom';
import { logoBlack } from '../constants/images';


const WhyHireWithWorkdeskVA = () => {
    useEffect(() => {
        new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        }).init();
    }, []);
    return (
        <section className="why-hire-section pt-100 pb-70">
            <div className="container">
                <div className="section-title text-center mb-5">
                    <h2>
                        Why Hire With <Link to="/" ><img src={logoBlack} alt="WorkDesk VA Logo" style={{height: '40px', display: 'inline-block', marginLeft: '8px'}} /></Link>
                    </h2>
                    <p className="mb-0">
                        Solve your most pressing workforce challenges with <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span> — your trusted remote staffing partner. We connect you with bilingual,
                        pre-vetted, and industry-trained professionals ready to deliver results from day one.
                    </p>
                </div>

                <div className="row">
                    {/* Top-Tier Talent */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-star"></i>
                            </div>
                            <h3>Top-Tier Talent</h3>
                                <p>
                                    With only a top 1% acceptance rate, we handpick remote software engineers and IT specialists who
                                    are rigorously vetted, expertly trained, and prepared to excel immediately on your projects.
                                </p>
                        </div>
                    </div>

                    {/* Risk Free Hiring */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.2s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-shield-alt"></i>
                            </div>
                            <h3>Risk Free Hiring</h3>
                            <p>
                                No upfront fees. Only pay when our remote staffing solution matches your needs—risk-free, simple, and designed for your success every time.
                            </p>
                        </div>
                    </div>

                    {/* Payroll & Benefits */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.3s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-file-invoice-dollar"></i>
                            </div>
                            <h3>Payroll & Benefits</h3>
                            <p>
                                From recruitment to payroll, we handle every detail so you can focus on growth—leaving the admin, benefits, and compliance to us.
                            </p>
                        </div>
                    </div>

                    {/* Access Trained Talent */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.4s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-users"></i>
                            </div>
                            <h3>Access Trained Talent</h3>
                            <p>
                                Tap into the top 1% of virtual healthcare talent—pre-vetted, trained, and ready to work in your time zone now.
                            </p>
                        </div>
                    </div>

                    {/* Compliance You Trust */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.5s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-lock"></i>
                            </div>
                            <h3>Compliance You Trust</h3>
                            <p>
                                HIPAA, SOC2, ISO 27001, and GDPR-compliant staffing to protect your sensitive data and meet every industry standard with confidence.
                            </p>
                        </div>
                    </div>

                    {/* Cost Effective Hiring */}
                    <div className="col-lg-4 col-md-6">
                        <div className="feature-card text-center mb-4 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.6s">
                            <div className="icon-wrapper mb-4">
                                <i className="fas fa-hand-holding-usd"></i>
                            </div>
                            <h3>Cost Effective Hiring</h3>
                            <p>
                                Reduce hiring costs by up to 70% compared to in-house staff—without sacrificing quality, productivity, or the results you expect.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};


// Add workdeskva-link CSS for special styling
// You can move this to your main CSS file if preferred
// Styles moved to style.css for better maintainability and site branding

export default WhyHireWithWorkdeskVA;
